/**
 * The open-clue panel (presentational). Shows the value + prompt to everyone; the
 * expected `response` is rendered ONLY when passed (host view). Players and the
 * presentation screen never receive a `response` over the wire (FR-9.2/9.3), so
 * there is nothing to leak here — this component just displays whatever the
 * role-filtered state contains.
 */

export interface CluePanelProps {
  value: number;
  prompt: string;
  categoryName?: string;
  /** Host-only expected response. Undefined for players/presentation. */
  response?: string;
}

export function CluePanel({
  value,
  prompt,
  categoryName,
  response,
}: CluePanelProps): React.JSX.Element {
  return (
    <div className="clue-panel" data-testid="clue-panel">
      <div className="clue-panel__value">
        {categoryName ? `${categoryName} — ` : ''}${value}
      </div>
      <div className="clue-panel__prompt" data-testid="clue-prompt">
        {prompt}
      </div>
      {response !== undefined && response !== '' && (
        <div className="clue-panel__response" data-testid="clue-response">
          <div className="clue-panel__response-label">Correct response (host only)</div>
          {response}
        </div>
      )}
    </div>
  );
}
